import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import smoothie250 from "@/assets/products/gobelet-smoothie-250ml.png";
import smoothie350 from "@/assets/products/gobelet-smoothie-350ml.png";
import smoothie470 from "@/assets/products/gobelet-smoothie-470ml.png";
import smoothie590 from "@/assets/products/gobelet-smoothie-590ml.png";

const config: ProductPageConfig = {
  name: "Gobelets smoothie rPET recyclé",
  breadcrumbName: "Gobelets smoothie rPET",
  subtitle: "Alternative durable pour smoothies, jus et boissons fraîches",
  features: ["Contact alimentaire", "rPET recyclé", "Transparent", "Résistant", "Disponible en stock"],
  variants: [
    { ref: "GVPET8OZ", capacity: "250 ml (8 oz)", material: "rPET recyclé", color: "Transparent", packaging: "Carton de 1 000 (20 x 50)", palette: "20 cartons", image: smoothie250 },
    { ref: "GVPET12OZ", capacity: "350 ml (12 oz)", material: "rPET recyclé", color: "Transparent", packaging: "Carton de 1 000 (20 x 50)", palette: "20 cartons", image: smoothie350 },
    { ref: "GVPET16OZ", capacity: "470 ml (16 oz)", material: "rPET recyclé", color: "Transparent", packaging: "Carton de 1 000 (20 x 50)", palette: "16 cartons", image: smoothie470 },
    { ref: "GVPET20OZ", capacity: "590 ml (20 oz)", material: "rPET recyclé", color: "Transparent", packaging: "Carton de 1 000 (20 x 50)", palette: "12 cartons", image: smoothie590 },
  ],
};

const GobeletsSmoothie = () => <ProductPageLayout config={config} />;
export default GobeletsSmoothie;
